export const REFUND_TYPE = {
  BOOKING: "booking",
  PRODUCT: "product",
  SERVICE: "service",
} as const;

export const formatRefundAction = (action?: string | null) => {
  if (!action) return "—";
  return action
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const REFUND_TYPE_OPTIONS = [
  { value: "", label: "All Types" },
  { value: REFUND_TYPE.BOOKING, label: "Booking" },
  { value: REFUND_TYPE.PRODUCT, label: "Product" },
  { value: REFUND_TYPE.SERVICE, label: "Service" },
];

export const REFUND_STATUS = {
  PENDING: "pending",
  PROCESSING: "processing",
  PAID: "paid",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
} as const;

/** @deprecated use REFUND_STATUS — kept for existing imports */
export const REFUND_STATUS_FILTER = REFUND_STATUS;

export const REFUND_STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: REFUND_STATUS.PENDING, label: "Pending" },
  { value: REFUND_STATUS.PROCESSING, label: "Processing" },
  { value: REFUND_STATUS.PAID, label: "Paid" },
  { value: REFUND_STATUS.SUCCEEDED, label: "Succeeded" },
  { value: REFUND_STATUS.FAILED, label: "Failed" },
];

export const REFUND_STATUS_LABEL: Record<string, string> = {
  [REFUND_STATUS.PENDING]: "Pending",
  [REFUND_STATUS.PROCESSING]: "Processing",
  [REFUND_STATUS.PAID]: "Paid",
  [REFUND_STATUS.SUCCEEDED]: "Succeeded",
  [REFUND_STATUS.FAILED]: "Failed",
};

export const REFUND_STATUS_BADGE: Record<string, string> = {
  [REFUND_STATUS.PENDING]: "light-warning",
  [REFUND_STATUS.PROCESSING]: "light-info",
  [REFUND_STATUS.PAID]: "light-success",
  [REFUND_STATUS.SUCCEEDED]: "light-success",
  [REFUND_STATUS.FAILED]: "light-danger",
};

export const normalizeRefundStatus = (status?: string | null) =>
  status?.toLowerCase() ?? "";

export const formatRefundStatus = (status?: string | null) =>
  REFUND_STATUS_LABEL[normalizeRefundStatus(status)] ?? status ?? "N/A";

export const getRefundStatusBadgeColor = (status?: string | null) =>
  REFUND_STATUS_BADGE[normalizeRefundStatus(status)] ?? "light-secondary";

export const canRetryRefundPayment = (status?: string | null) =>
  normalizeRefundStatus(status) === REFUND_STATUS.FAILED;
